import { extractData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import { ArticlePageDtoShema } from "./schemas";
import type { ArticleType } from "./types";

export const mapDtoToArticlePage = (dto: unknown): ArticleType[] => {
  const parsed = safeParseWithFallback(
    ArticlePageDtoShema,
    dto,
    "mapDtoToArticlePage",
  );

  return extractData(parsed, dto, []);
};
